import { render } from "./PhotographHeader.vue?vue&type=template&id=521afbf1&scoped=true"
import script from "./PhotographHeader.vue?vue&type=script&lang=js"
export * from "./PhotographHeader.vue?vue&type=script&lang=js"

import "./PhotographHeader.vue?vue&type=style&index=0&id=521afbf1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521afbf1"]])

export default __exports__